module.exports = __webpack_public_path__ + "img/eye-infinite-player.28066eb6.jpg";